"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../Anchor"));
require("./Notification.scss");
var Notification = function Notification(_ref) {
  var className = _ref.className,
    variation = _ref.variation,
    type = _ref.type,
    title = _ref.title,
    description = _ref.description,
    link = _ref.link,
    linkText = _ref.linkText,
    icon = _ref.icon,
    elementLocator = _ref.elementLocator,
    restDescription = _ref.restDescription;
  return _react.default.createElement("div", {
    className: "notification " + variation + " " + type + " " + className,
    "data-locator": elementLocator
  }, icon && _react.default.createElement(_reactSvg.ReactSVG, {
    className: "icon",
    src: icon,
    "data-locator": elementLocator + "-icon"
  }), _react.default.createElement("div", null, title && _react.default.createElement("span", {
    className: "title",
    "data-locator": elementLocator && elementLocator + "-title"
  }, title), description && _react.default.createElement("span", {
    className: "description",
    "data-locator": elementLocator && elementLocator + "-description"
  }, description), linkText && _react.default.createElement(_Anchor.default, (0, _extends2.default)({}, link, {
    elementLocator: elementLocator && elementLocator + "-link-text"
  }), linkText), restDescription && _react.default.createElement("span", {
    className: "description",
    "data-locator": elementLocator && elementLocator + "-rest-description"
  }, restDescription)));
};
Notification.defaultProps = {
  className: '',
  variation: '',
  type: '',
  title: '',
  description: '',
  icon: '',
  linkText: '',
  link: {},
  elementLocator: '',
  restDescription: ''
};
var _default = Notification;
exports.default = _default;
module.exports = exports["default"];